import { createApp } from 'vue'
import HelloWorld from '../components/HelloWorld.vue'
import ContentWorkbench from '../components/workbench/ContentWorkbench.vue'
import PlannerWorkbench from '../components/planner/PlannerWorkbench.vue'
import IdeaBankPage from '../components/ideas/IdeaBankPage.vue'

// Component registry — add new components here
const components = {
  HelloWorld,
  ContentWorkbench,
  PlannerWorkbench,
  IdeaBankPage,
}

document.addEventListener('DOMContentLoaded', () => {
  // Navbar toggle
  const toggle = document.querySelector('.navbar__toggle')
  const menu = document.querySelector('.navbar__menu')

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('active')
      menu.classList.toggle('active')
    })
  }

  // Mount Vue islands
  document.querySelectorAll('[data-vue-component]').forEach((el) => {
    const name = el.dataset.vueComponent
    const component = components[name]

    if (!component) {
      console.warn(`Vue component "${name}" not found in registry`)
      return
    }

    const props = el.dataset.vueProps ? JSON.parse(el.dataset.vueProps) : {}
    const app = createApp(component, props)
    app.mount(el)
  })
})
